module.exports = __webpack_public_path__ + "images/mdj/members/message/inboxlist/inboxlist_icon02-c0633dfc35eaaf479645fef96dfdbd0e.png";